import { IAvatarAssetColor } from './IAvatarAssetColor';

export interface IAvatarAssetEyeColor extends IAvatarAssetColor {
}
